
        import { initPublications, filterPublications, filterByYear, getYears } from './src/js/modules/publications-renderer.js';

        // Initialize publications on page load
        initPublications().then(() => {
            // Populate year filter
            const yearFilter = document.getElementById('year-filter');
            if (yearFilter) {
                const years = getYears();
                years.forEach(year => {
                    const option = document.createElement('option');
                    option.value = year;
                    option.textContent = year;
                    yearFilter.appendChild(option);
                });
            }
        });

        // Setup search functionality
        const searchInput = document.getElementById('pub-search');
        if (searchInput) {
            let searchTimeout;
            searchInput.addEventListener('input', (e) => {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(() => {
                    filterPublications(e.target.value);
                }, 300); // Debounce search
            });
        }

        // Setup year filter
        const yearFilter = document.getElementById('year-filter');
        if (yearFilter) {
            yearFilter.addEventListener('change', (e) => {
                filterByYear(e.target.value);
            });
        }

        // Setup clear filters button
        const clearBtn = document.getElementById('clear-filters');
        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                if (searchInput) searchInput.value = '';
                if (yearFilter) yearFilter.value = 'all';
                filterPublications('');
            });
        }
    